import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Link, withRouter } from 'react-router-dom'
import { Icon } from 'loyal-react'

const ExistsOnboardingBox = ({ isHidden, onboardingId, createDate, location: { search } }) => {
  return (
    <Fragment>
      <div id='box-login' className={`box-login row pb-4 ${isHidden && 'd-none'}`}>
        <div className='col-12 col-md-6 col-lg-4 mr-auto ml-auto py-3 px-3 radius bg-white border border-color-ui-3 pb-5 mb-5'>
          <div className='row'>
            <div className='col-12'>
              <Icon className='icon icon_clock color-warning' />
              <h1 className='h1 txt-title txt-circular-book mt-2 mb-1'>Sua solicitação está em análise!</h1>
              <p className='txt-body-sm mb-half'>
                <strong>Solicitação:</strong> {onboardingId}
                <br />
                <strong>Data:</strong> {createDate}
              </p>
              <p className='txt-body-sm mb-half'>Em até 72h enviaremos uma resposta.</p>
              <p className='txt-body-sm mb-half'>Fique atento.</p>
            </div>
          </div>
          <div className='col-12 col-md-12 txt-center mt-2 px-0'>
            <Link
              to={`/login${search}`}
              className='btn btn-sm btn-featured d-block txt-uppercase txt-circular-black'
              role='button'
            >
              Voltar para o início
            </Link>
          </div>
        </div>
      </div>
    </Fragment>
  )
}

ExistsOnboardingBox.propTypes = {
  isHidden: PropTypes.bool,
  location: PropTypes.shape({
    search: PropTypes.string
  })
}

export default withRouter(ExistsOnboardingBox)
